import React, { Component } from 'react';
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { setErrorFields } from "../../helpers/validationHelpers";
import route from '../../config/routes';
import { MESSAGE } from '../../config/index';
import { API_URL, S3 } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import {
    fetchLookups
} from "../../actions/lookup_action";
import Service from '../../helpers/service';
import { connect } from 'react-redux';
import LoadingButton from '../fields/LoadingButton';
import CSVReader from 'react-csv-reader';
import $ from 'jquery'

const { EMPTY, IMPORT } = MESSAGE;
class Import extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsNotFound: [],
            fields: [],
            fileInfo: "",
            collections: [],
            collectionsData: "",
            url: API_URL.ADMIN_COLLECTION_API + 'import-collections/',
            routeName: route.IMPORT_COLLECTION,
            displayError: false,
            error_message: '',
            error_type: '',
            isLoading: false,
            btnIsDisable: true
        };

        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        var that = this;
        $(".close-slide").click(function () {
            that.resetForm();
            window.closeImportModal();
        });
        if (this.props.brands.length < 1) {
            this.props.fetchLookups("BRAND");
        }
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.collections.length === 0) {
            let errorObject = setErrorFields("collections", Helping.getMessageString(EMPTY, "Collections"));
            this.setState({ ...errorObject });
            formHasError = true;
        }
        return formHasError;
    }

    handleChange = (data, fileInfo) => {
        this.setState({ fileInfo });

        if (this.checkIfHeadersAvailable()) {
            this.fillCollectionArrayData(data);
        }
        else {
            this.setState({
                displayError: true
            })
        }
    }

    handleHeader = (header) => {
        const fieldName = header.toLowerCase().replace(/\W/g, '_');
        this.setState({
            fields: [...this.state.fields, fieldName]
        });
        return fieldName;
    }

    checkIfHeadersAvailable = () => {
        let flag = true;
        const defaultFields = [
            "collection_code",
            "collection_name",
            "collection_type",
            "collection_description",
            "reward_item",
            "item_codes",
            "brand",
            "status"
        ], absentFields = [];

        defaultFields.map(field => {
            let fieldFound = this.state.fields.includes(field);

            if (!fieldFound) {
                flag = false;
                absentFields.push(field);
            }
        });
        this.setState({
            fieldsNotFound: absentFields
        });
        return flag;
    }

    fillCollectionArrayData = (data) => {
        const collections = [];

        data.map(d => {

            if (d['status']) {
                let obj = {};
                let { content, id } = this.getBrandContent(d['brand']);

                obj.name = d['collection_name'];
                obj.code = d['collection_code'];
                obj.description = d['collection_description'];
                obj.reward_code = d['reward_item'];
                obj.badge_code = d['badge_item'] ? d['badge_item'] : null;
                obj.items = Helping.convertCommaStringIntoArray(d['item_codes']);
                obj.total_rewards = d['no_of_rewards'] ? Number(d['no_of_rewards']) : 0;
                obj.exp_days = d['time_based'] === 'NO' ? 0 : Number(d['time_duration']);
                obj.type = d['collection_type'];
                obj.brand = d['brand'];
                obj.brand_id = id;
                obj.brand_content = content;
                obj.is_archive = d['archive'] ? d['archive'] : 0;
                obj.is_active = d['active'] ? d['active'] : 1;
                obj.is_awardable = d['awardable'] ? d['awardable'] : 1;
                obj.landscape_thumbnail_url = this.getImagePath('landscape-thumbnail', d['collection_code']);
                obj.portrait_thumbnail_url = this.getImagePath('portrait-thumbnail', d['collection_code']);
                obj.banner_url = this.getImagePath('banner', d['collection_code']);
                obj.featured_banner_url = this.getImagePath('feature-banner', d['collection_code']);

                collections.push(obj);
            }
        })

        this.setState({
            collections: collections,
            collectionsData: JSON.stringify(collections, undefined, 4),
            displayError: false,
            fieldsNotFound: [],
            btnIsDisable: false,
            isLoading: false
        })
    }

    getImagePath(value, code) {
        return S3.URL + `/collections/${value}/` + Helping.removeSpacialCharactersOtherThanNumbersFromString(code, false).toLowerCase() + ".jpg";
    }

    getBrandContent = (name) => {
        let brand = Helping.getSingleByName(this.props.brands, name);
        let content = { ...JSON.parse(brand[0].content), name };
        let id = brand[0].id;

        return {
            content,
            id
        };
    }


    scrollToTop = () => {
        $('.import-collection').animate({ scrollTop: 0 }, 'slow');
    }

    resetForm = () => {
        $('#csvFile').val('');
        this.setState(
            {
                collectionsData: "",
                collections: [],
                fieldsNotFound: [],
                displayError: false,
                btnIsDisable: true,
                isLoading: false,
                fileInfo: ""
            }
        );
    }

    onSave(e) {
        e.preventDefault();

        let $this = this,
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            isLoading: true
        });

        let body = {
            data: JSON.parse($this.state.collectionsData),
        };
        Service.postCall(this.state.url, body).then(response => {
            if (response.data.status === 200) {
                this.setState(
                    {
                        error_message: Helping.getMessageString(IMPORT, "Collections"),
                        error_type: "success",
                        isLoading: false
                    }, () => { this.resetForm(); this.scrollToTop(); }
                );
            }
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false,
                    isLoading: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "importing collections")
            }, () => { this.scrollToTop(); })
        });
    }

    render() {
        const parserOptions = {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            transformHeader: header => this.handleHeader(header)
        };

        return (
            <>
                <div class="right-slider import-collection">
                    <div class="slide-top">
                        <div class="slide-header">
                            <h4 class="title">Import Collections</h4>
                            <span class="caption">Add new collections to your system now.</span>
                        </div>
                        {/* <span class="close-slide">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                        </span> */}
                    </div>

                    {this.state.error_message &&
                        <Notification type={this.state.error_type} message={this.state.error_message} callback={this.removeNetworkError} />
                    }
                    <form action="" class="info">
                        <div class="form-group">

                            <label>Upload CSV File</label>
                            <div class="ImgField">
                                <label class="imgFieldArea" for="csvFile">
                                    <span class="icon fileImg">
                                        {this.state.fileInfo ?
                                            <div>{this.state.fileInfo.name}</div>
                                            : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                </svg>
                                            )}
                                    </span>
                                    Click here upload file
                                </label>

                                <CSVReader
                                    cssClass="react-csv-input"
                                    accept=".csv, text/csv"
                                    inputId="csvFile"
                                    cssInputClass="imgFieldArea"
                                    inputName="csvFile"
                                    onError={(error) => console.log(error)}
                                    onFileLoaded={this.handleChange}
                                    parserOptions={parserOptions}
                                    inputStyle={{ visibility: 'hidden' }}
                                />
                            </div>
                        </div>

                        {this.state.displayError && (
                            <div>
                                {this.state.fieldsNotFound.map(fieldName => {
                                    return <p className="errors">Header Not Found: <span>{fieldName}</span></p>
                                })}
                            </div>
                        )}

                        <div class="form-group">
                            <label for="description">JSON Data</label>
                            <textarea class="form-control" id="data" value={this.state.collectionsData} rows="20" onChange={e => this.setState({ collectionsData: e.target.value })}></textarea>
                        </div>

                        <div class="slide-btn">
                            <div className="float-left">
                                <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                            </div>

                            <div class="float-right">
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>

                                {this.state.isLoading ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)} disabled={this.state.btnIsDisable}>{this.state.isLoading ? "Loading..." : "Save"}</button>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        brands: state.brands
    }
}

const mapDispatchToProps = {
    addCurrentRoute,
    fetchLookups
}

export default connect(mapStateToProps, mapDispatchToProps)(Import)